import { ActionTree } from 'vuex'
import { processLocalizedURLAddress } from '@vue-storefront/core/helpers'
import { TaskQueue } from '@vue-storefront/core/lib/sync'
import getApiEndpointUrl from '@vue-storefront/core/helpers/getApiEndpointUrl'
import RootState from '@vue-storefront/core/types/RootState'
import config from 'config'
import { DEFAULT_PAGE_SIZE } from '../constants'
import { CategoryReviewState } from '../types/CategoryReview'
import * as types from './mutation-types'

const actions: ActionTree<CategoryReviewState, RootState> = {
  async load ({ commit, state }, { categoryId, page, pageSize = DEFAULT_PAGE_SIZE }) {
    let response

    try {
      response = await TaskQueue.execute({
        url: processLocalizedURLAddress(
          getApiEndpointUrl(config.categoryReview, 'list_endpoint')
            .replace('{{categoryId}}', categoryId + '')
            .replace('{{page}}', page + '')
            .replace('{{pageSize}}', pageSize + '')
        ),
        payload: {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
          mode: 'cors'
        }
      })
    } catch (error) {
      // Only clear when another performer's reviews would otherwise render on this page;
      // a failed reload of the current performer (e.g. pagination) keeps what is shown.
      if (state.categoryId !== Number(categoryId)) commit(types.RESET)
      throw error
    }

    if (response.code !== 200 || !response.result) {
      if (state.categoryId !== Number(categoryId)) commit(types.RESET)
      throw new Error(response.result?.errorMessage || 'Failed to load reviews')
    }

    commit(types.SET_LIST, { ...response.result, categoryId: Number(categoryId) })

    return response
  },
  async submit ({ commit, rootGetters }, { categoryId, rating, nickname, title, detail }) {
    const response = await TaskQueue.execute({
      url: processLocalizedURLAddress(
        getApiEndpointUrl(config.categoryReview, 'submit_endpoint')
      ),
      // A string result makes the sync layer spawn its own toast; the modal owns that message
      silent: true,
      payload: {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        mode: 'cors',
        body: JSON.stringify({
          token: rootGetters['user/getToken'],
          review: { categoryId, rating, nickname, title, detail }
        })
      }
    })

    if (response.code !== 200) {
      // vsf-api answers a rejected payload with the Magento message as a plain string
      const serverMessage = typeof response.result === 'string'
        ? response.result
        : response.result?.errorMessage
      const error: any = new Error(serverMessage || 'Failed to submit review')
      error.code = response.code
      throw error
    }

    return response
  }
}

export default actions
